module.exports = __webpack_public_path__ + "static/media/shop.7ac434a4.svg";